import React from "react";

const SettlementStatusBadge = ({ status }) => {

    const getClassName = () => {

        switch (status?.toLowerCase()) {

            case "paid":
            case "completed":
                return "status-paid";

            case "pending":
                return "status-pending";

            case "processing":
                return "status-processing";

            case "failed":
                return "status-failed";

            case "rejected":
                return "status-rejected";

            default:
                return "status-pending";
        }

    };

    return (
        <span className={getClassName()}>
            {status}
        </span>
    );

};

export default SettlementStatusBadge;